import { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';

import TargetingProvider from '@/contexts/Targeting/TargetingProvider';
import SupplySource from './SupplySource';

import type { ValidationError } from 'sonata-react-components';
import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';
import type { GoalInterface } from 'sonata-static-storage/lib/schemas/campaign/goal.schema';
import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  baseCurrency: BaseCurrencyInterface;
  error?: ValidationError;
  familyType?: CampaignFamilyEnum;
  flightsGoals: GoalInterface[];
  onChange: (targeting: TargetingBaseType) => void;
  targeting: TargetingBaseType;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function SupplySourceWrapper({
  baseCurrency,
  error,
  familyType,
  flightsGoals,
  onChange,
  targeting,
  user,
  userRoles
}: Props) {
  return (
    <TargetingProvider
      familyType={familyType}
      onChange={onChange}
      targeting={targeting}
      user={user}
      userRoles={userRoles}
    >
      <SupplySource baseCurrency={baseCurrency} error={error} flightsGoals={flightsGoals} />
    </TargetingProvider>
  );
}

export default SupplySourceWrapper;
